module.exports = require('./bundle').core()
